import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";
import {Link} from "react-router-dom";
import {imageMap} from "../../../../images/imageMap.ts";
import Icon from "../../../../components/selfcare/Icon.tsx";
import {ALL_FIBER} from "../../../../components/coverageMap/CoverageMap.ts";
import Routing from "../../../../Routing.ts";
import CoverageMapContainer from "../../../../components/coverageMap/CoverageMapContainer.tsx";
import IconCheck from "../../../../components/icons/IconCheck.tsx";
import IconRocket from "../../../../components/icons/IconRocket.tsx";
import IconTechnician from "../../../../components/icons/IconTechnician.tsx";
import IconExcavator from "../../../../components/icons/IconExcavator.tsx";
import IconRouterSmall from "../../../../components/icons/IconRouterSmall.tsx";
import IconMail from "../../../../components/icons/IconMail.tsx";
import IconCustomerService from "../../../../components/icons/IconCustomerService.tsx";
import IconSupporter from "../../../../components/icons/IconSupporter.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../../../util/events.ts";
import OrderAddressSearchComponent from "../../../../components/order/OrderAddressSearchComponent.tsx";

const questions_installation_process: Question[] = [
    {
        question: "Eniig, EWII, GlobalConnect, Nord Energi, SEF, Syd Energi og RAH",
        answer: <>
            <div className="article article--connect">
                <section className="installation-procedure-container">
                    <div className="installation-procedure installation-procedure-start">
                        <Icon component={IconCheck}/>
                        <p>Ordrebekræftelse</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconMail}/>
                        <p>Velkomstmail</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconRouterSmall}/>
                        <p>Udstyr</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconExcavator}/>
                        <p>Etablering af fiber</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconTechnician}/>
                        <p>Teknikerbesøg</p>
                    </div>
                    <div className="installation-procedure installation-procedure-end">
                        <Icon component={IconRocket}/>
                        <p>Online</p>
                    </div>
                </section>
            </div>
            <div className="article">
                <div className="paragraph">
                    <p>
                        Først får du besøg af en entreprenør og dernæst en tekniker.
                    </p>
                    <p>
                        Entreprenøren fører fiberen fra vejen hen til den udvendige fiberboks på din husmur.
                        Her behøver du ikke være hjemme, da entreprenøren ikke skal ind i din bolig (med mindre du får andet at vide fra os).
                    </p>
                    <p>
                        Efterfølgende installerer teknikeren en fiberboks i din bolig, og der skal være en myndig person til stede under besøget, da teknikeren skal ind i din bolig.
                    </p>
                    <p>
                        Fiberboksen består af to bokse; en indvendig og en udvendig. Den indvendige fiberboks bliver installeret på indersiden af den husmur, som vender ud mod vejen.
                        Den udvendige fiberboks bliver installeret samme sted som den indvendige boks, men på ydersiden af muren.
                    </p>
                    <p>
                        Når teknikeren er færdig, kan du tilslutte <Link to="/hjaelp/udstyr/hvilken-router-foelger-med">din router</Link> til den indvendige fiberboks og så er du online med dit nye internet!
                    </p>
                </div>
            </div>
        </>
    },
    {
        question: "Fibia",
        answer: <>
            <div className="article article--connect">
                <section className="installation-procedure-container">
                    <div className="installation-procedure installation-procedure-start">
                        <Icon component={IconCheck}/>
                        <p>Ordrebekræftelse</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconCustomerService}/>
                        <p>Opkald fra fiberkonsulent</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconExcavator}/>
                        <p>Gravning hvis nødvendigt</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconMail}/>
                        <p>Velkomstmail</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconTechnician}/>
                        <p>Teknikerbesøg</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconRouterSmall}/>
                        <p>Udstyr</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconRocket}/>
                        <p>Online</p>
                    </div>
                    <div className="installation-procedure installation-procedure-end">
                        <Icon component={IconTechnician}/>
                        <p>Tekniker måler op</p>
                    </div>
                </section>
            </div>
            <div className="article">
                <div className="paragraph">
                    <p>
                        Først får du et opkald fra en fiberkonsulent indenfor 14 dage.
                        I opkaldet aftaler du, hvordan og hvornår en entreprenør skal nedgrave fiberen på din grund.
                        Entreprenørens gravearbejde kan foregå på din og offentlig grund.
                        Fiberkonsulenten informerer dig, hvis entreprenøren skal grave på offentlig grund, i så fald skal entreprenøren nemlig søge om gravetilladelse, før etableringen af dit fibernet kan starte.
                    </p>
                    <p>
                        Når entreprenøren har gravet fiberen hen til din bolig, får du en mail med en dato for et teknikerbesøg, hvor en tekniker færdiggør fiberinstallationen i din bolig.
                        Der skal være en myndig person til stede under besøget, da teknikeren skal ind i din bolig.
                    </p>
                </div>
            </div>
        </>
    },
    {
        question: "Energi Fyn",
        answer: <>
            <div className="article article--connect">
                <section className="installation-procedure-container">
                    <div className="installation-procedure installation-procedure-start">
                        <Icon component={IconCheck}/>
                        <p>Ordrebekræftelse</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconCustomerService}/>
                        <p>Opkald fra fiberkonsulent</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconExcavator}/>
                        <p>Gravning hvis nødvendigt</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconSupporter}/>
                        <p>Tidsbestilling<br/>Opkald fra tekniker</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconMail}/>
                        <p>Velkomstmail</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconTechnician}/>
                        <p>Teknikerbesøg</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconRouterSmall}/>
                        <p>Udstyr</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconRocket}/>
                        <p>Online</p>
                    </div>
                    <div className="installation-procedure installation-procedure-end">
                        <Icon component={IconTechnician}/>
                        <p>Tekniker måler op</p>
                    </div>
                </section>
            </div>
            <div className="article">
                <div className="paragraph">
                    <p>
                        Først får du et opkald fra en fiberkonsulent indenfor 14 dage.
                        I opkaldet aftaler du, hvordan og hvornår en entreprenør skal lave etablering af fibernet på din grund.
                        Efterfølgende får du en mail med en dato, hvor entreprenøren starter nedgravningen af fibernettet &ndash; det kan foregå på både din grund og ved forsyning i det offentlige.
                    </p>
                    <p>
                        Når entreprenøren har gravet fiberen ned på din grund, bliver du kontaktet af en tekniker.
                        I aftaler, hvornår teknikeren skal færdiggøre fiberinstallationen inde i din bolig.
                        Når teknikeren har færdiggjort installationen, kan du sætte din router til fiberboksen, og så kan du tage dit nye internet i brug.
                    </p>
                </div>
            </div>
        </>
    },
    {
        question: "TDC NET",
        answer: <>
            <div className="article article--connect">
                <section className="installation-procedure-container">
                    <div className="installation-procedure installation-procedure-start">
                        <Icon component={IconCheck}/>
                        <p>Ordrebekræftelse</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconMail}/>
                        <p>Velkomstmail</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconCustomerService}/>
                        <p>Opkald fra fiberkonsulent</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconRouterSmall}/>
                        <p>Udstyr</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconExcavator}/>
                        <p>Etablering af fiber</p>
                    </div>
                    <div className="installation-procedure">
                        <Icon component={IconTechnician}/>
                        <p>Teknikerbesøg</p>
                    </div>
                    <div className="installation-procedure installation-procedure-end">
                        <Icon component={IconRocket}/>
                        <p>Online</p>
                    </div>
                </section>
            </div>
            <div className="article">
                <div className="paragraph">
                    <p>
                        Du får først et opkald fra en fiberkonsulent.
                        I opkaldet aftaler I, hvornår og hvordan fiberen skal graves ind til din bolig.
                    </p>
                    <p>
                        Så graver en entreprenør fiberen ind til din bolig.
                        Du behøver ikke være hjemme, da entreprenøren ikke skal ind i din bolig (medmindre du får andet at vide fra os).
                    </p>
                    <p>
                        Til sidst får du besøg af en tekniker, som installerer en indvendig og udvendig fiberboks i din bolig.
                        Der skal være en myndig person til stede under besøget, da teknikeren skal ind i din bolig.
                    </p>
                    <p>
                        Fiberboksen består af to bokse; en indvendig og en udvendig.
                        Den indvendige fiberboks bliver installeret på indersiden af husmuren, som vender ud mod vejen.
                        Den udvendige fiberboks bliver installeret samme sted som den indvendige boks, men på ydersiden af muren.
                    </p>
                    <p>
                        Når teknikeren er færdig med din fibernet-installation, kan du tilslutte din router til den indvendige fiberboks og tage dit internet i brug.
                    </p>
                </div>
            </div>
        </>
    }
]

const questions_good_to_know: Question[] = [
    {
        question: "Skal jeg være hjemme, når teknikeren kommer?",
        answer: <>
            <p>
                Når du får besøg af en tekniker, skal der være en myndig person til stede, som kan lukke teknikeren ind og besvare spørgsmål om den indvendige installation.
                Hvis der ikke er en myndig person til stede, koster det 699&nbsp;kr. for et forgæves teknikerbesøg.
            </p>
        </>
    },
    {
        question: "Kan jeg ændre min teknikertid til fiberinstallation?",
        answer: <>
            <p>
                Du modtager en dato for teknikerbesøget i god tid, så du ved hvornår, du skal være hjemme.
                Hvis du ønsker en ny tid, kan du ringe til os på <a href="tel:+4588772000">88&nbsp;77&nbsp;20&nbsp;00</a> minimum 2 dage før den oprindelige dato.
            </p>
            <p>
                På Fibias fiber kan vi ikke ændre din teknikertid for dig &ndash; du skal i stedet ringe direkte til teknikeren, du har haft kontakt med.
            </p>
        </>
    },
    {
        question: "Hvad er leveringstiden, når en tekniker skal hjem til mig og lave fiberinstallationen?",
        answer: <>
            <p>
                Det tager oftest 4-6 uger, fra du bestiller fiber, til du kan tage det i brug.
                Leveringstiden afhænger af, hvornår du kan få besøg af en tekniker og en entreprenør, og hvor lang tid det tager at grave fiberen ned hos dig.
            </p>
        </>
    },
    {
        question: "Hvad er en fiberboks, og hvordan ser den ud?",
        answer: <>
            <div className="article article--connect">
                <div className="paragraph">
                    <p>
                        En fiberboks er en lille grå eller hvid plastboks, som bliver monteret for enden af fiberkablet, der er gravet ned på din grund.
                        Der er både en udvendig fiberboks og en indvendig fiberboks.
                    </p>
                    <p>
                        Den udvendige fiberboks bliver sat op på ydersiden af din bolig ud mod vejen.
                        Teknikeren tilkobler den udvendige og indvendige fiberboks ved at bore et hul (indføringspunkt) gennem muren/soklen, hvor den udvendige fiberboks sidder.
                        Så trækker teknikeren fiberkablet gennem muren og tilslutter den indvendige fiberboks til det.
                    </p>
                    <p>
                        Den udvendige fiberboks kan se sådan her ud:
                    </p>
                </div>
            </div>
            <div className="article article--connect">
                <img
                    className="box-shadow"
                    src={imageMap.help.equipment.udvendig_fiberboks}
                    alt="Ved en fibernet-installation får du installeret en udvendig fiberboks på din bolig"
                />
            </div>
            <div className="article article--connect">
                <div className="paragraph">
                    <p>
                        Den indvendige fiberboks bliver sat op på indersiden af din husmur ud for indføringspunktet til den udvendige fiberboks.
                        Når teknikeren kommer, skal området omkring den indvendige fiberboks være ryddet, så der er arbejdsplads.
                        Derudover skal der være en stikkontakt i nærheden af den indvendige fiberboks, da den skal tilkobles strøm.
                    </p>
                    <p>
                        Hvilken indvendig fiberboks du får, afhænger af hvilken underleverandør der leverer din fiber.
                        Den indvendige fiberboks kan se ud som dem på billederne:
                    </p>
                </div>
            </div>
            <div className="article article--2 article--connect">
                <img
                    className="box-shadow"
                    src={imageMap.help.equipment.indvendig_fiberboks_tdc}
                    alt="Ved en fibernet-installation får du installeret en indvendig fiberboks i din bolig ud mod vejen"
                />
                <img
                    className="box-shadow"
                    src={imageMap.help.equipment.indvendig_fiberboks}
                    alt="Ved en fibernet-installation får du installeret en indvendig fiberboks i din bolig ud mod vejen"
                />
            </div>
            <div className="article">
                <div className="paragraph">
                    <p>
                        Hvis du ønsker, at teknikeren skal placere den indvendige fiberboks et andet sted end ved indføringspunktet, kan du aftale det med teknikeren.
                        Det koster dog et større gebyr.
                        Du kan højst få den placeret 20 meter fra indføringspunktet.
                    </p>
                    <p>
                        Når teknikeren er færdig, kan du sætte din router til den indvendige fiberboks og tage dit internet i brug.
                        Du får en fiber router tilsendt som del af dit fiber-abonnement.
                    </p>
                    <p>
                        Vi har ofte kampagnepriser på fibernet, så{' '}
                        <button
                            className={'link'}
                            onClick={() => DispatchHighLightAddressSearchEvent(true)}
                        >
                            tjek din adresse her
                        </button>{' '}
                        for at se hvilke gode tilbud, du kan få.
                    </p>
                </div>
            </div>
        </>
    },
]

export default function FiberInstallationArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <h2>Hvordan får jeg fibernet?</h2>
                    <div className="paragraph">
                        <p>
                            Hvis du ikke har fiber installeret på din adresse i dag, skal en tekniker etablere en fiberforbindelse til din adresse.
                            Vi sørger for hele fibernet-installationen, og hvis det bliver nødvendigt for teknikeren at grave på din bopæl, bliver fliser, græsplæne og blomsterbede efterladt pænt.
                        </p>
                        <p>
                            Hvis der har været fiber på din adresse før, kan der allerede være en fibernet-boks i din bolig.
                            Hvis fibernet-boksen er for gammel, skal en tekniker hjem til dig og skifte den til en nyere model, før du kan få fibernet.
                            Det koster 699&nbsp;kr. for at etablere fibernet på din bopæl og skifte den gamle fibernet-boks.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvordan foregår installationen af fibernet?</h2>
                        <p>
                            Installationsprocessen varierer afhængig af fiber-infrastrukturen og vores underleverandør i dit nærområde.
                            Når du bestiller fiber hos os, starter vi med at vurdere, hvordan din fiberinstallation skal foregå og hvilken underleverandør, der skal udføre den.
                            Teknikeren, der skal installere fiber hos dig, skal nemlig vide, hvor fiberen er placeret i dit område, og hvilke muligheder der er for at føre fiberen ind til din bolig.
                        </p>
                    </div>
                    <img
                        className="paragraph-image hide-on-small-devices mb0"
                        src={imageMap.help.subscription.fiber_installation_desktop}
                        alt="Grafik som viser etableringsprocessen for fibernet"
                    />
                    <img
                        className="paragraph-image hide-on-large-devices mb0"
                        src={imageMap.help.subscription.fiber_installation_mobile}
                        alt="Grafik som viser etableringsprocessen for fibernet"
                    />
                </div>

                <div className="article">
                    <h2>Tjek vores underleverandørers installationsprocesser</h2>
                    <QuestionAnswerComponent questions={questions_installation_process}/>
                </div>

                <div className="article">
                    <div className="paragraph prices">
                        <h2>Hvad koster det at få lagt fibernet ind?</h2>
                        <table cellSpacing="0" className="prices-table">
                            <tbody>
                            <tr>
                                <td>Teknikerbesøg og fiberinstallation:</td>
                                <td>699 kr.</td>
                            </tr>
                            <tr>
                                <td>Oprettelse:</td>
                                <td>
                                    398 kr.
                                    <div className="tool-tip">
                                        &#9432;
                                        <span className="tool-tip-text">
                                Ved køb af produkter med 1000 Mbit er oprettelse gratis.
                            </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Ekstra gravemeter ved etablering af fibernet:</td>
                                <td>
                                    450 kr. pr. meter
                                    <div className="tool-tip">
                                        &#9432;
                                        <span className="tool-tip-text">
                                Hvis du ønsker at få fiberboksen placeret længere nede af husmuren, som afviger fra en standard fiberinstallation, så koster det 450 kr. pr. ekstra gravemeter.
                                Gælder kun på TDC fiber.
                                Andre priser gælder ved andre netværk, som fiberkonsulenten kan informere dig om.
                            </span>
                                    </div><br/>
                                    (Gælder kun TDC NET)
                                </td>
                            </tr>
                            <tr>
                                <td>Hvis du ønsker begge fibernet-bokse placeret indvendigt på husmuren ud mod vejen:</td>
                                <td>
                                    1650 kr.
                                    <div className="tool-tip">
                                        &#9432;
                                        <span className="tool-tip-text">
                                Ønsker du at få begge fiberbokse placeret indenfor, så du slipper for at den ydre fiberboks hænger på den ydre husfacade &ndash; så koster det 1650&nbsp;kr. ekstra, udover prisen på en standard fiberinstallation.
                                Gælder kun på TDC fiber.
                                Andre priser gælder ved andre netværk, som fiberkonsulenten kan informere dig om.
                            </span>
                                    </div><br/>
                                    (Gælder kun TDC NET og EWII)
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="article article--connect">
                    <div className="paragraph">
                        <h2 className="align-center">Hvilken fiber ligger i mit område?</h2>
                        <p className="align-center">
                            På vores fiber-kort kan du se fiber-infrastrukturen i dit område.
                        </p>
                    </div>
                    <CoverageMapContainer regionPreset={ALL_FIBER} fiberMapOnly={true} static={false}/>
                    <p className="coverage-map-disclaimer">
                        Vi kan ikke garantere at kunne levere til alle adresser i de markerede områder.
                    </p>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <p>
                            Vil du også have <Link to={Routing.Broadband.Fiber}>lynhurtigt fibernet</Link>?
                            Tjek din adresse herunder og se, hvad du kan&nbsp;få!
                        </p>
                        <OrderAddressSearchComponent/>
                    </div>
                </div>

                <div className="article">
                    <h2>Godt at vide om en fibernet-installation</h2>
                    <QuestionAnswerComponent questions={questions_good_to_know}/>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "leveringstid",
                        "name": "Leveringstid på internet"
                    },
                    {
                        "category": "bestilling",
                        "article": "kan-jeg-faa-1000-mbit",
                        "name": "Kan jeg få 1.000 Mbit?"
                    },
                    {
                        "category": "bestilling",
                        "article": "opsig-eksisterende-abonnement",
                        "name": "Skal jeg selv opsige mit eksisterende abonnement?"
                    },
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    }
                ]}
            />
        </>
    )
}
